import React, { useMemo } from "react";
import { Button, Modal } from "react-bootstrap";
import { defineMessages, FormattedMessage } from "react-intl";
import styled from "styled-components";
import { BookingOption, DailyDatum } from "../../modification/bookingOptionModel";
import { messages } from "../messages";

export const modalMessages = defineMessages({
  title: {
    id: "reservationDetail.combinedBookingModal.title",
    defaultMessage: "Combined rate",
  },
});

interface CombinedBookingModalProps {
  isOpen: boolean;
  bookingOption: BookingOption;
  onClose: () => void;
  maxWidth?: string;
  overflowVisible?: boolean;
}

export const ModalStyledTable = styled.table`
  border-collapse: collapse;
  width: 100%;

  td,
  th {
    border: 1px solid #ced4da;
    padding: 10px;
  }

  tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  tr:hover {
    background-color: #ddd;
  }

  th {
    text-align: left;
    color: #ff6136;
  }
`;

export const StyledModal = styled(Modal)`
  .close {
    color: white;
    opacity: 1;

    &:hover {
      opacity: 0.75;
    }
  }
`;

export interface TableRow {
  date: string;
  dailyAmount: number;
  inventoryTicker: string;
}

export function CombinedBookingModal({
  isOpen,
  onClose,
  bookingOption,
}: CombinedBookingModalProps) {
  const rows: TableRow[] = useMemo(() => {
    const dates = Object.keys(bookingOption.dailyData);
    dates.sort();
    return dates.map(it => {
      const dailyDatum: DailyDatum = bookingOption.dailyData[it];
      return {
        date: it,
        dailyAmount: dailyDatum.rate.value,
        inventoryTicker: dailyDatum.inventory.ticker.value,
      };
    });
  }, [bookingOption.dailyData]);
  return (
    <StyledModal centered show={isOpen} onHide={onClose} backdrop="static">
      <Modal.Header className="bg-[#FF6136] text-white text-xl" closeButton>
        <FormattedMessage {...modalMessages.title} />
      </Modal.Header>
      <Modal.Body className="p-4">
        <ModalStyledTable>
          <thead>
            <tr>
              <th>
                <FormattedMessage {...messages.date} />
              </th>
              <th>
                <FormattedMessage {...messages.amount} />
              </th>
              <th>
                <FormattedMessage {...messages.inventoryLine} />
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map(row => (
              <tr>
                <td>{row.date}</td>
                <td>{row.dailyAmount}</td>
                <td>{row.inventoryTicker}</td>
              </tr>
            ))}
          </tbody>
        </ModalStyledTable>
        <div className="flex justify-center mt-4">
          <Button className="ml-0" onClick={onClose}>
            <div className="font-weight-bold">
              <FormattedMessage {...messages.close} />
            </div>
          </Button>
        </div>
      </Modal.Body>
    </StyledModal>
  );
}
